var exports = {
  "uW": "SettingsSection.module__section___NWFoVT",
  "bV": "SettingsSection.module__sectionHeader___NWFoVT",
  "sq": "SettingsSection.module__sectionTitleRow___NWFoVT",
  "vO": "SettingsSection.module__sectionActions___NWFoVT",
  "N1": "SettingsSection.module__subsectionActions___NWFoVT",
  "Gf": "SettingsSection.module__sectionTitle___NWFoVT",
  "yV": "SettingsSection.module__sectionDescription___NWFoVT",
  "f5": "SettingsSection.module__sectionContent___NWFoVT",
  "t8": "SettingsSection.module__subsectionHeader___NWFoVT",
  "Wf": "SettingsSection.module__subsectionTitle___NWFoVT",
  "Yq": "SettingsSection.module__subsectionDescription___NWFoVT",
  "No": "SettingsSection.module__subsectionContent___NWFoVT",
};

module.exports = exports;
